import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { CoreDataDto } from '@sal/core/application/dtos';
import { CoreData } from '../state/pages/pages.state';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class PagesService {
    private readonly http = inject(HttpClient);

    async getCoreData(): Promise<CoreData> {
        return await firstValueFrom(this.http.get<CoreDataDto>(`${environment.endpoint}/core`));
    }
}
